const IconSearch = (props) => {
    return (
        <svg className={props.className} xmlns="http://www.w3.org/2000/svg" width="29.938" height="29.938" viewBox="0 0 29.938 29.938" fill="none" stroke="#486f88">
            <g id="Group_111" data-name="Group 111" transform="translate(-772.644 -466.585)">
                <circle id="Ellipse_6" data-name="Ellipse 6" cx="12.501" cy="12.501" r="12.501" transform="translate(773.394 467.335)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                <line id="Line_27" data-name="Line 27" x1="6.797" y1="6.797" transform="translate(794.724 488.665)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
            </g>
        </svg>
    )
}

export default IconSearch;